import { useCallback } from 'react';
import { invariant } from 'ts-invariant';
import type { OnActionType } from '../../../../context/ActionsProvider/context';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';
import useControlBlockMethod from '../controlBlockMethod/useControlBlockMethod';

type ModalActionPayload = {
  modalId?: string;
  operation: 'show' | 'hide';
};

function useModalActions() {
  const { onCallBlockMethod } = useControlBlockMethod();

  const onControlModal: OnActionType = useCallback(
    async ({ action, actionContext, instanceId }) => {
      const payload = action.payload as ModalActionPayload;
      const blockId = payload.modalId;
      const operation = payload.operation;

      invariant(blockId, 'Modal id is required');

      switch (operation) {
        case 'show':
          await onCallBlockMethod({
            blockId,
            methodName: 'showModal',
            action,
            actionContext,
            instanceId,
          });
          break;
        case 'hide':
          await onCallBlockMethod({
            blockId,
            methodName: 'hideModal',
            action,
            actionContext,
            instanceId,
          });
          break;
        default:
          break;
      }
      return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    },
    [onCallBlockMethod],
  );

  return { onControlModal };
}

export default useModalActions;
